import { Component, HostListener, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { tsParticles } from '@tsparticles/engine';
import { loadAll } from '@tsparticles/all';
import { EmailService } from 'src/app/core/services/email.service';
import { AlertService } from 'src/app/core/services/alert.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  selectedCategory = 'all';
  currentYear = new Date().getFullYear();
  contactForm: FormGroup;
  categories = [
    { label: 'Todos', value: 'all' },
    { label: 'App', value: 'filter-app' },
    // { label: 'Cards', value: 'filter-card' },
    // { label: 'LogoMarca', value: 'filter-logo' },
    { label: 'Web', value: 'filter-web' },
  ];
  allPortfolioItems: any[] = [];
  portfolioItems: any[] = [];
  modal = false
  err = false
  send = false;
  windowScrolled = false
  active = false
  id = 'tsparticles';
  private configs = {
    particles: {
      number: {
        value: 200
      },
      color: {
        value: "#ffffff"
      },
      links: {
        enable: true,
        distance: 200
      },
      shape: {
        type: "circle"
      },
      opacity: {
        value: 0.7
      },
      size: {
        value: {
          min: 4,
          max: 6
        }
      },
      move: {
        enable: true,
        speed: 2
      }
    },
    background: {
      color: "#0d111e",

    },
    poisson: {
      enable: true
    },
    interactivity: {
      events: {
        onHover: {
          enable: true,
          mode: "repulse"
        }
      }
    },
    responsive: [
      {
        maxWidth: 768, // Apply these options when screen width is 768px or less
        options: {
          particles: {
            number: {
              value: 40 // Fewer particles on smaller screens
            }
          }
        }
      },
      {
        maxWidth: 480, // Apply these options when screen width is 480px or less
        options: {
          particles: {
            number: {
              value: 20 // Even fewer particles
            },
            size: {
              value: 2 // Smaller particles
            }
          }
        }
      }
    ]
  };


  constructor(private http: HttpClient, private emailService: EmailService, private alertService: AlertService, private fb: FormBuilder) {
    this.contactForm = this.fb.group({
      name: ['', [Validators.required, Validators.minLength(3)]],
      email: ['', [Validators.required, Validators.email]],
      subject: ['', [Validators.required, Validators.minLength(3)]],
      message: ['', [Validators.required, Validators.minLength(5)]],
    });
  }

  ngOnInit(): void {
    this.onScroll();
    this.setPortfolio();
    this.getPortfolio();
    this.filterPortfolio('all');
  }
  async ngAfterViewInit(): Promise<void> {
    await loadAll(tsParticles);
    // await loadFull(tsParticles);
    await tsParticles.load({
      id: this.id,
      options: this.configs,
    });
  }

  filterPortfolio(category: string): void {
    this.selectedCategory = category;

    this.portfolioItems = category === 'all'
      ? [...this.allPortfolioItems]
      : this.allPortfolioItems.filter(item => item.category === category);
  }

  shouldShow(itemCategory: string): boolean {
    return this.selectedCategory === 'all' || this.selectedCategory === itemCategory;
  }

  getPortfolio() {
    this.allPortfolioItems = [
      {
        title: 'JWT Angular',
        description: 'Exemplo de autenticação JWT',
        category: 'filter-web',
        image: '../../../assets/img/jwt-angular.png',
        link: 'https://github.com/Ivan-Vidal/jwt-angular-front',
        external: false
      },
      {
        title: 'Weekly Meal Planner',
        description: 'Planejador semanal de refeições',
        category: 'filter-web',
        image: '../../../assets/img/weekly-planner.png',
        link: 'https://meal-planner-front-hazel.vercel.app/meals',
        external: false
      },
      {
        title: 'PlantManager',
        description: 'Lembrete cuidar de suas plantas',
        category: 'filter-app',
        image: '../../../assets/img/portfolio/logo2.jpg',
        link: 'https://github.com/Ivan-Vidal/nlw5-plantManager',
        external: false
      }
    ]
  }

  setPortfolio(): void {
    this.getPortfolio();
    this.filterPortfolio('all');
  }

  sendEmail() {
    this.alertService.loadingAlert('Enviando...', 'Por favor, aguarde enquanto enviamos seu email.');
    if (this.contactForm.valid) {
      this.emailService.sendEmail(this.contactForm.value).subscribe({
        next: (response) => {
          this.alertService.close();
          this.alertService.success('Enviado!', `Email enviado com sucesso! <br/> Obrigado por entrar em contato.`);
          this.contactForm.reset(); // Reseta o formulário
        },
        error: (error) => {
          this.alertService.close();
          this.alertService.error('OPS!', `Erro ao enviar email. <br/> Por favor, tente novamente.`);
        }
      });
    } else {
      this.alertService.close();
      this.alertService.warning('OPS!', `Por favor, preencha todos os campos corretamente.`);
    }
  }

  activeModal() {
    let close = document.querySelector('.fa-bars')
    close.classList.add('fa-times')
  }

  removeModal() {
    document.querySelector('.fa-times').classList.remove('fa-times')
  }

  onClick() {

    if (!this.modal) {
      this.modal = true
      this.activeModal()
      console.log('ativei')
    } else if (this.modal) {
      this.modal = false
      this.removeModal()
      console.log('desativei')
    }
  }

  scrollToElement(element: any): void {
    console.log(element);
    (document.getElementById(element) as HTMLElement).scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
  }

  onScroll() {
    let backBlock = false
    if (document.body.scrollTop > 10 || document.documentElement.scrollTop > 10) {
      backBlock = true
    } else {
      backBlock = false
    }
  }

  @HostListener("window: scroll", [])
  onWindowScroll() {
    if (window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop > 10) {
      this.windowScrolled = true;
    } else if (this.windowScrolled && window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop < 10) {
      this.windowScrolled = false;
    }
  }
}
